import { Component, useEffect, useState } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import "@/App.css";
import useLenis from "@/hooks/useLenis";
import Home from "@/pages/Home";
import MenuPage from "@/pages/MenuPage";
import Intro, { INTRO_SEEN_KEY } from "@/components/Intro";
import PromoSong from "@/components/PromoSong";
import { CartProvider } from "@/context/CartContext";
import CartDrawer from "@/components/CartDrawer";
import { Toaster } from "@/components/ui/sonner";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }

  static getDerivedStateFromError(error) {
    return { error };
  }

  render() {
    if (this.state.error) {
      return (
        <div className="flex min-h-screen items-center justify-center bg-cream p-8 text-center">
          <div>
            <p className="font-display text-3xl font-black text-jet">Something crumbled.</p>
            <p className="mt-2 text-jet/70">Please refresh the page to get back to the flavor.</p>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

function ScrollToTop() {
  const { pathname, state } = useLocation();

  useEffect(() => {
    if (state && state.scrollTo) return; // section jump — Home scrolls to the target itself
    if (window.__lenis) window.__lenis.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname, state]);

  return null;
}

function App() {
  useLenis();
  const [introDone, setIntroDone] = useState(() => {
    try {
      if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return true;
      return window.localStorage.getItem(INTRO_SEEN_KEY) === "1";
    } catch {
      return true;
    }
  });

  return (
    <ErrorBoundary>
      <CartProvider>
        <PromoSong />
        {!introDone && <Intro onComplete={() => setIntroDone(true)} />}
        <BrowserRouter>
          <ScrollToTop />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/menu" element={<MenuPage />} />
          </Routes>
          <CartDrawer />
        </BrowserRouter>
        <Toaster position="top-center" />
      </CartProvider>
    </ErrorBoundary>
  );
}

export default App;
